/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: "https://login.microsoftonline.com/fa80f109-b245-4991-8a4e-9d4f7eb5ae11",
        redirectUri: process.env.REACT_APP_REDIRECTURI
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    default:
                        console.log(message);
                        return;
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info("this is info", message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

// The API uses this application's client ID as its audience (AzureAd:Audience).
// Self-token requests require the bare GUID resource identifier (AADSTS90009).
// Deployments targeting a separate API registration can override its scope.
export const apiRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE || `${process.env.REACT_APP_CLIENTID}/App.Access`]
};
